import React, { Component } from "react";
// import Lightbox from "react-images";

// import ImageDisplay from "./imageDisplay";
import Popup from "reactjs-popup";
import Code from "./code";

class GettingStarted extends Component {
  state = {
    lightboxIsOpen: false,
  };
  constructor(props) {
    super(props);
    this.manifest =
      '{\n\t"extension": {\n\t\t"name": "Extension Sample",\n\t\t"product-url": "https://sc1.checkpoint.com/documents/SmartConsole/Extensions/index.html",\n\t\t"provider": "extensions@checkpoint.com",\n\t\t"version": "1.0"\n\t},\n\t"locations": [{\n\t\t"location": "toolbar",\n\t\t"relevant-types": ["access-policy"],\n\t\t"ui-element": {\n\t\t\t"type": "button",\n\t\t\t"caption": "Hello World",\n\t\t\t"tooltip": "Hello World Extension",\n\t\t\t"action": {\n\t\t\t\t"browser-window": {\n\t\t\t\t\t"height": "550",\n\t\t\t\t\t"width": "950"\n\t\t\t\t},\n\t\t\t\t"details-level": "standard",\n\t\t\t\t"method": "get",\n\t\t\t\t"trigger-id": "import-access-policy-toolbar-get",\n\t\t\t\t"url": "index.html"\n\t\t\t}\n\t\t}\n\t}]\n}';
    this.indexPage =
      "<!DOCTYPE html>\n<html xmlns=\"http://www.w3.org/1999/xhtml\">\n<head>\n\t<title>Hello World</title>\n</head>\n<body onload=\"smxProxy.sendRequest('get-context', null, 'onContext');\">\n\n\t<h1>Hello World</h1>\n\t<p id=\"context\" />\n\n\t<script>\n\t//callback\n\tfunction onContext(value) {\n\t\t//do something with the JSON formatted context\n\t\tdocument.getElementById('context').innerHTML = JSON.stringify(value);\n\t}\n\t</script>\n</body>\n</html>";
  }
  render() {
    return (
      <div>
        <p>
          SmartConsole Extensions is an open platform in SmartConsole that
          enables you to integrate web-based components. For example, you can
          create a web interface for an existing ticketing system, and integrate
          it in SmartConsole so associated tickets can be displayed for every
          rule in the Rule Base.
        </p>
        <p>
          Customers, vendors, partners and third-parties can develop their own
          extensions and host them in SmartConsole.
        </p>
        <p>
          <b>Extension Samples</b>
          <ul>
            <li>
              <a href="https://github.com/CheckPointSW/smart-console-extensions/tree/master/examples/hello-world">
                Hello World
              </a>{" "}
              (HTML, JavaScript)
            </li>
            <li>
              <a href="https://github.com/CheckPointSW/smart-console-extensions/tree/master/examples/show-gateways-interfaces">
                Show Gateways Interfaces
              </a>{" "}
              (HTML, JavaScript)
            </li>
            <li>
              <a href="https://github.com/CheckPointSW/smart-console-extensions/tree/master/examples/connectivity-check">
                Connectivity Check
              </a>{" "}
              (React)
            </li>
          </ul>
        </p>

        <p>
          <b>Basic Components</b>
        </p>
        <ul>
          <li>A web application</li>
          <li>
            Hosting service- A web-service where you can host your extension.
            Ensure that your hosting service supports SSL, and is accessible by SmartConsole clients.
          </li>
          <li>
            <a href="#Extension Manifest">Extension manifest</a> - A JSON file
            that contains the information needed to display and manage the
            extension.
          </li>
        </ul>

        <p>
          <b>Additional Configuration</b>
        </p>
        <ul>
          <li>
            <a href="#Extension Context">Extension context</a> - A set of
            parameters, provided to the extension service, that contains
            relevant information about the extension location in which it
            resides.
          </li>
          <li>
            You can manage extensions from SmartConsole. For more information,
            see the{" "}
            <a href="https://sc1.checkpoint.com/documents/R80.20/SmartConsole_OLH/EN/html_frameset.htm?topic=documents/R80.20/SmartConsole_OLH/EN/b6fjzpJZDELmPhIhAF_DvQ2&anchor=o207014">
              {" "}
              R80.20 SmartConsole online help
            </a>
            ,{" "}
            <a href="https://sc1.checkpoint.com/documents/R80.30/SmartConsole_OLH/EN/html_frameset.htm?topic=documents/R80.30/SmartConsole_OLH/EN/b6fjzpJZDELmPhIhAF_DvQ2&anchor=o207014">
              {" "}
              R80.30 SmartConsole online help{" "}
            </a>
            ,{" "}
            <a href="https://sc1.checkpoint.com/documents/R80.40/SmartConsole_OLH/EN/Content/Topics-OLH/b6fjzpJZDELmPhIhAF_DvQ2.htm?Highlight=preferences#SmartConsole_Extensions_..1">
              {" "}
              R80.40 SmartConsole online help
            </a>{" "}
            ,{" "}
            <a href="https://sc1.checkpoint.com/documents/R81/SmartConsole_OLH/EN/Content/Topics-OLH/b6fjzpJZDELmPhIhAF_DvQ2.htm?Highlight=preferences#SmartConsole_Extensions_..1">
              R81 SmartConsole online help
            </a>{" "}
            ,{" "}
            <a href="https://sc1.checkpoint.com/documents/R81.10/SmartConsole_OLH/EN/Topics-OLH/b6fjzpJZDELmPhIhAF_DvQ2.htm?Highlight=preferences#SmartConsole_Extensions_..1">
              R81.10 SmartConsole online help
            </a>
            {" "}
            or{" "}
            <a href="https://sc1.checkpoint.com/documents/R81.20/SmartConsole_OLH/EN/Topics-OLH/b6fjzpJZDELmPhIhAF_DvQ2.htm?Highlight=preferences#SmartConsole_Extensions_..1">
              R81.20 SmartConsole online help
            </a>
          </li>
        </ul>
        <p>
          <b>Extension Hosting Service</b>
        </p>

        <p>
          An extension service is a web service - that enables the extension. It
          accepts HTTPS connections from SmartConsole.
        </p>
        <p>Extension Prerequisites:</p>
        <ul>
          <li>Accessible JSON formatted manifest for users to import.</li>
          <b>Note -</b> The hosting service should return this JSON with header:
          <b> Content-Type: application/json</b>
          <li>
            The hosting service supports SSL.{" "}
            <span>The certificate can be self-signed.</span>
          </li>
          <li>The hosting service serves HTTPS GET/POST requests methods.</li>
        </ul>
      </div>
    );
  }
}

export default GettingStarted;
